import React from "react";
import Str from "shared/components/Str";

import "./Terms.scss";

const Terms = () => (
	<div className="sms-terms">
		<p className="sms-terms-text">
			<Str>We do not share phone numbers with advertisers.</Str>
		</p>
		<span className="sms-terms-text">
			<Str>Questions?</Str>
		</span>
		{" "}
		<a
			className="sms-terms-link"
			href="https://help.okcupid.com/article/202-sms-verification"
			target="_blank"
			rel="noopener noreferrer"
		>
			<Str>Contact support.</Str>
		</a>
	</div>
);

export default Terms;



// WEBPACK FOOTER //
// ./src/shared/components/SmsMigrationModal/Terms.jsx